export default __webpack_public_path__ + "static/media/tech-stack-mobile.940d19f6.png";